import ExternalLink from './ExternalLink';
export default ExternalLink;
export { default as InternalLink } from './InternalLink';
